// Category IDs
export const categoryIDs = [
  { id: 1, category: "Student Assessments" },
  { id: 2, category: "Observation Week" },
  { id: 3, category: "Holiday" },
  { id: 4, category: "The Sleeping Beauty" },
  { id: 5, category: "Summer Concerto" },
  { id: 6, category: "Land of the Sweets" },
  { id: 7, category: "Giselle" },
  { id: 8, category: "Nylia Ballet Company" },
  { id: 9, category: "Nylia Ballet Youth Company" },
  { id: 10, category: "Community & Family" },
];

// {
//     eventName: `Title of the Event`,
//     category: `Used for sorting`,
//     startDate: `Must be in the format: June 27, 2026`,
//     endDate: `Must be in the format: June 27, 2026`, // Optional, if multiple days
//     eventTime: `7 pm`,
//     location: `Nylia Ballet Academy`,
//     image: `ImageID in EventPopup`,
//     links: [{link: "http://www.example.com", label: "Button Label"}],
//     description: `Short caption`,
//     details: `Full details for pop-up`,
//   },

export const eventsList = [
  {
    eventName: `NBC & NBYC: Company Photoshoot`,
    category: 8,
    startDate: `March 22, 2026`,
    eventTime: `10:00 am`,
    location: `Nylia Ballet Academy`,
    image: 7,
    links: [
      {
        link: "http://www.nyliaballetacademy.com/nyliaballetcompany",
        label: "Nylia Ballet Company",
      },
      {
        link: "http://www.nyliaballetacademy.com/nyliaballetyouthcompany",
        label: "Nylia Ballet Youth Company",
      },
    ],
    description: `An exclusive glimpse into the next chapter of Nylia Ballet Company`,
    details: `This private photoshoot is designed exclusively for dancers of the Nylia Ballet Company and the Nylia Ballet Youth Company, offering a first look into our upcoming season. Dancers will step into new productions, including highlights from The Sleeping Beauty, while showcasing curated dancewear and visual concepts that will define our marketing for the year ahead. This experience goes beyond photos, it’s an introduction to the artistry, vision, and storytelling that will shape everything to come.`,
  },
  {
    eventName: `Student Assessments`,
    category: 1,
    startDate: `March 25, 2026`,
    endDate: `March 28, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 1,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `Assessments will take place during regular class lessons.`,
    details: `Students will be assessed by the Artistic Staff on current technical ballet level, ability to focus, energy level, individual maturity, physical abilities, potential, and passion for dance. Correct level placement ensures that all dancers learn and solidify each aspect of their training before moving on, creating a strong foundation to build upon and maintaining the level of excellence that you expect for your child.`,
  },
  {
    eventName: `Observation Week`,
    category: 2,
    startDate: `April 22, 2026`,
    endDate: `April 25, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 2,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `Step inside the magic, join us for Observation Week at Nylia Ballet Academy!`,
    details: `The Ballet Academy is delighted to open our doors for Observation Week! We warmly invite our dancers’ family and friends to join us in celebrating their journey and progress. Each student may bring up to two guests to experience the dedication, joy, and artistry that fills our classes. Join us for this special opportunity that allows us to share the passion and hard work that make our community so special.`,
  },

  {
    eventName: `The Sleeping Beauty: Cast Photoshoot`,
    category: 4,
    startDate: `April 19, 2026`,
    eventTime: `12:00 pm`,
    location: `Nylia Ballet Academy`,
    image: 6,
    links: [
      {
        link: "/performances/thesleepingbeauty2026",
        label: "Full Details",
      },
    ],
    description: `Step into the magic of The Sleeping Beauty. Secure your cast photoshoot experience today!`,
    details: `Be part of something truly unforgettable with our The Sleeping Beauty Cast Photoshoot. This is a special opportunity for dancers to capture the elegance, character, and beauty of this timeless production in a professional setting. Each session is thoughtfully designed to highlight your role and artistry, creating keepsakes you’ll treasure long after the curtain falls. To ensure a seamless and personalized experience, all photo packages must be purchased in advance of the photoshoot. Spaces are limited, and we can’t wait to celebrate this magical journey with you.`,
  },

  {
    eventName: `Nylia Ballet Company Auditions`,
    category: 8,
    startDate: `April 26, 2026`,
    eventTime: `1:30 pm`,
    location: `Nylia Ballet Academy`,
    image: 4,
    links: [
      {
        link: "/nyliaballetcompany",
        label: "Nylia Ballet Company",
      },
    ],
    description: `Audition to be a part of El Paso's ballet company!`,
    details: `Nylia Ballet Company warmly invites adults ages 18+ to audition, whether you’re stepping into the studio for the very first time or returning as an experienced dancer. This is a welcoming, supportive space where passion matters more than perfection, and every dancer has the opportunity to grow, perform, and belong. Selected dancers will be part of an exciting season featuring Summer Concerto, Land of the Sweets, and Giselle. Come as you are, and take the next step in your dance journey with us.`,
  },
  {
    eventName: `Nylia Ballet Youth Company Auditions`,
    category: 9,
    startDate: `April 26, 2026`,
    eventTime: `11:00 am`,
    location: `Nylia Ballet Academy`,
    image: 5,
    links: [
      {
        link: "/nyliaballetyouthcompany",
        label: "Nylia Ballet Youth Company",
      },
    ],
    description: `Audition to be a part of El Paso's youth ballet company!`,
    details: `At Nylia Ballet Youth Company, dancers are given the opportunity to grow in a supportive, inspiring environment while enjoying exclusive benefits designed to help them succeed. Company members receive fully waived summer intensive fees, 20% off tuition, and so much more, making high-quality training and performance opportunities more accessible than ever. Dancers will build strong technique, confidence, and artistry while performing in beautiful productions, Summer Concerto, Land of the Sweets & Giselle. It’s a place to learn, grow, and truly shine both on and off the stage.`,
  },
  {
    eventName: `Mom & Me Week`,
    category: 10,
    startDate: `May 13, 2026`,
    endDate: `May 16, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 8,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `A special bond, a shared love of dance, Mom & Me Week!`,
    details: `Mom & Me Week invites moms to step into the studio alongside their dancers for a shared class experience. Together, you’ll witness the technique, artistry, and dedication your dancer brings to each moment, celebrating their progress and the joy of ballet. It’s a meaningful opportunity to connect and experience the passion behind every step.`,
  },
  {
    eventName: `Dad & Me Week`,
    category: 10,
    startDate: `June 10, 2026`,
    endDate: `June 13, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 9,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `Celebrate dance together. Dad & Me Week!`,
    details: `Dad & Me Week invites dads to join their dancers in the studio for a special shared class experience. This is a unique opportunity to witness the technique, focus, and artistry your dancer brings to every step, while celebrating their progress and love of ballet. It’s a meaningful way to connect, support, and share in the joy of their dance journey.`,
  },

  {
    eventName: `The Sleeping Beauty: Full-Run Throughs`,
    category: 4,
    startDate: `June 22, 2026`,
    endDate: `June 26, 2026`,
    eventTime: `5:30 pm`,
    location: `Nylia Ballet Academy`,
    image: 6,
    links: [
      {
        link: "/performances/thesleepingbeauty2026",
        label: "Full Details",
      },
    ],
    description: `The final countdown. The Sleeping Beauty Production Week`,
    details: `This full week of rehearsals leading up to the show is where everything truly comes together for The Sleeping Beauty. Dancers spend each day refining choreography, strengthening technique, and deepening their connection to the story and their roles. With focused rehearsals, full run-throughs, and final adjustments, the cast builds confidence, stamina, and unity as a company. It’s an exciting and transformative week filled with dedication, anticipation, and the energy of knowing opening night is just around the corner.`,
  },
  {
    eventName: `The Sleeping Beauty: Dress Rehearsal`,
    category: 4,
    startDate: `June 27, 2026`,
    eventTime: `7:30 am`,
    location: `Magoffin Auditorium`,
    image: 6,
    links: [
      {
        link: "/performances/thesleepingbeauty2026",
        label: "Full Details",
      },
    ],
    description: `Last rehearsal before the show!`,
    details: `Step into the final moments before the curtain rises with the The Sleeping Beauty Dress Rehearsal. This is where every detail comes together. Costumes, lighting, and performance, transforming weeks of dedication into a fully realized production. Dancers experience the excitement of performing in full costume while refining timing, spacing, and artistry on stage. It’s a special behind-the-scenes milestone that captures the anticipation, discipline, and magic just before opening night.`,
  },
  {
    eventName: `The Sleeping Beauty`,
    category: 4,
    startDate: `June 27, 2026`,
    eventTime: `7 pm`,
    location: `Magoffin Auditorium`,
    image: 6,
    links: [
      {
        link: "/performances/thesleepingbeauty2026",
        label: "Learn More",
      },
    ],
    description: `A timeless masterpiece comes to life. The Sleeping Beauty brought to the El Paso, Ciudad Juárez, and Las Cruces community.`,
    details: `Experience the magic, artistry, and storytelling of The Sleeping Beauty as it comes alive on stage, brought to life by the dedicated dancers of Nylia Ballet Company. This production celebrates the unifying power of the arts across El Paso, Ciudad Juárez, and Las Cruces, inviting audiences to be part of a shared experience of beauty, creativity, and community. With stunning choreography, enchanting music, and passionate performers, it’s a performance you won’t want to miss.`,
  },
  {
    eventName: `Nylia Ballet Academy's Summer Intensive`,
    category: 10,
    startDate: `July 13, 2026`,
    endDate: `July 25, 2026`,
    eventTime: `Time varies by division`,
    location: `Nylia Ballet Academy`,
    image: 1,
    links: [
      {
        link: "/summerintensives",
        label: "Learn More",
      },
    ],
    description: `Two weeks. Endless growth. Join our Summer Intensive!`,
    details: `Our Summer Intensive at Nylia Ballet Academy offers comprehensive ballet training for dancers of all ages and levels. Divisions include Petite Ballet (Ages 3–7), Junior Ballet (Ages 8–13), Pre-Professional (Teen & Adult), and Beginner Ballet (Teen & Adult), ensuring every dancer receives training tailored to their level. Over two focused weeks, students will refine technique, develop artistry, and prepare for a stunning final performance in Summer Concerto with the Nylia Ballet Company. Apply today to reserve your spot and experience growth, inspiration, and the joy of ballet this summer!
    `,
  },
  {
    eventName: `The Sleeping Beauty: Auditions`,
    category: 4,
    startDate: `February 1, 2026`,
    eventTime: `10:00 am`,
    location: `Nylia Ballet Academy`,
    image: 6,
    links: [
      {
        link: "/performances/thesleepingbeauty2026",
        label: "Full Details",
      },
    ],
    description: `Audition for The Sleeping Beauty!`,
    details: `Audition for The Sleeping Beauty, our second performance of this timeless ballet, brought to life with Tchaikovsky’s unforgettable music, breathtaking sets and costumes, and a world of magic, fairies, and princesses. With more than 30 roles to be cast, this is a beautiful opportunity to become part of an enchanting production and share the stage in a truly magical performance with the Nylia Ballet Company.`,
  },
  {
    eventName: `Summer Concerto`,
    category: 5,
    startDate: `July 25, 2026`,
    eventTime: `8:00 pm`,
    location: `Nylia Ballet Academy`,
    image: 6,
    links: [
      {
        link: "/performances/summerconcerto2026",
        label: "Full Details",
      },
    ],
    description: `A summer in harmony!`,
    details: `Celebrate the season with an inspiring Summer Concerto filled with beautiful music.`,
  },
  {
    eventName: `Land of the Sweets: Auditions`,
    category: 6,
    startDate: `August 16, 2026`,
    eventTime: `10:00 pm`,
    location: `Nylia Ballet Academy`,
    image: 10,
    links: [
      {
        link: "/performances/landofthesweets2027",
        label: "Full Details",
      },
    ],
    description: `Join the magic. Audition today!`,
    details: `Step into the magical world of Land of the Sweets, our original production inspired by The Nutcracker, revealing the untold backstory of the Rat Queen and the Nutcracker before the beloved holiday tale begins.`,
  },
  {
    eventName: `Student Assessments`,
    category: 1,
    startDate: `September 9, 2026`,
    endDate: `September 12, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 1,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `Assessments will take place during regular class lessons.`,
    details: `Students will be assessed by the Artistic Staff on current technical ballet level, ability to focus, energy level, individual maturity, physical abilities, potential, and passion for dance. Correct level placement ensures that all dancers learn and solidify each aspect of their training before moving on, creating a strong foundation to build upon and maintaining the level of excellence that you expect for your child.`,
  },
  {
    eventName: `Observation Week`,
    category: 2,
    startDate: `September 16, 2026`,
    endDate: `September 19, 2026`,
    eventTime: `In-Class`,
    location: `Nylia Ballet Academy`,
    image: 2,
    links: [
      {
        link: "/classes",
        label: "Class Schedule",
      },
    ],
    description: `Step inside the magic, join us for Observation Week at Nylia Ballet Academy!`,
    details: `The Ballet Academy is delighted to open our doors for Observation Week! We warmly invite our dancers’ family and friends to join us in celebrating their journey and progress. Each student may bring up to two guests to experience the dedication, joy, and artistry that fills our classes. Join us for this special opportunity that allows us to share the passion and hard work that make our community so special.`,
  },
  {
    eventName: `Land of the Sweets`,
    category: 6,
    startDate: `January 30, 2027`,
    eventTime: `7:00 pm`,
    location: `Magoffin Auditorium`,
    image: 11,
    links: [
      {
        link: "/performances/landofthesweets2027",
        label: "Full Details",
      },
    ],
    description: `Uncover the Nutcracker's untold beginning!`,
    details: `Step into the magical world of Land of the Sweets, our original production inspired by The Nutcracker, revealing the untold backstory of the Rat Queen and the Nutcracker before the beloved holiday tale begins.`,
  },
  {
    eventName: `Bring-a-Friend Week`,
    category: 6,
    startDate: `October 14, 2026`,
    endDate: `October 17, 2026`,
    eventTime: `During Class`,
    location: `Nylia Ballet Academy`,
    image: 10,
    description: `Your friends are invited to your dance class for FREE!`,
    details: `If your friend registers in the month of October, $15 credit to you and your friend!`,
  },
  {
    eventName: `Movie Night: Coraline`,
    category: 10,
    startDate: `October 23, 2026`,
    eventTime: `6:00 pm`,
    location: `Nylia Ballet Academy`,
    image: 13,
    description: `Tickets available at the front desk!`,
    details: `Grab your PJs, blankets & pillows and join us for a cozy, spooky night of Coraline!`,
  },
  // {
  //   eventName: `Giselle: Auditions`,
  //   category: 7,
  //   startDate: `February 7, 2027`,
  //   eventTime: `10:00 am`,
  //   location: `Nylia Ballet Academy`,
  //   image: 6,
  //   links: [
  //     {
  //       link: "/performances/giselle2027",
  //       label: "Full Details",
  //     },
  //   ],
  //   description: `Bring Giselle to life!`,
  //   details: `Join us for auditions for Giselle, one of ballet's most beloved romantic classics.`,
  // },
  // {
  //   eventName: `Giselle`,
  //   category: 7,
  //   startDate: `June 27, 2027`,
  //   eventTime: `7:00 pm`,
  //   location: `Magoffin Auditorium`,
  //   image: 6,
  //   links: [
  //     {
  //       link: "/performances/giselle2027",
  //       label: "Full Details",
  //     },
  //   ],
  //   description: `Whisper with the Wilis tonight.!`,
  //   details: `Join us for auditions for Giselle, one of ballet's most beloved romantic classics.`,
  // },
];
